export default "__VITE_ASSET__mvkgdd6B__"